import { Component, Output, EventEmitter, OnInit, isDevMode } from '@angular/core'
import { slideRight } from '../shared/animations';
import { AnyTxtRecord } from 'dns';
import { HttpService } from '../shared';

declare var DFK: any;

@Component({
    selector: 'dfk-header',
    template: require('./header.component.html'),
    styles: [require('./header.component.scss')],
    providers: [HttpService],
    animations: [slideRight],
    host: {
        '(window:focus)': 'windowOnFocus()'
    }
})

export class HeaderComponent implements OnInit {

    private UserName = '';
    private UserAvatar = '';
    private SingOutLink = '';
    private SignInLink = '';
    private Balance = '';

    private pricingURL = '';
    private resourcesURL = '';
    private webScraperURL = '';
    private renderHTMLURL = '';
    private extractSERPDataURL = '';
    private urlToPdfURL = '';
    private captureScreenshotURL = '';
    private balance = '';

    @Output() goEvent = new EventEmitter();

    constructor(private httpService: HttpService) {
        if (isDevMode()) {
			this.pricingURL = 'http://localhost:8081/pricing';
            this.resourcesURL = 'http://localhost:8081/help';
            this.webScraperURL = 'http://localhost:8081/web-scraper';
            this.renderHTMLURL = 'http://localhost:8081/render-web';
            this.extractSERPDataURL = 'http://localhost:8081/serp';
            this.urlToPdfURL = 'http://localhost:8081/url-to-pdf';
            this.captureScreenshotURL = 'http://localhost:8081/url-to-screenshot';
            this.SingOutLink = 'http://localhost:8005/signout';
            this.SignInLink = 'http://localhost:8005/signin';
		} else {
            this.pricingURL = 'https://dataflowkit.com/pricing';
            this.resourcesURL = 'https://dataflowkit.com/help';
            this.webScraperURL = 'https://dataflowkit.com/web-scraper';
            this.renderHTMLURL = 'https://dataflowkit.com/render-web';
            this.extractSERPDataURL = 'https://dataflowkit.com/serp';
            this.urlToPdfURL = 'https://dataflowkit.com/url-to-pdf';
            this.captureScreenshotURL = 'https://dataflowkit.com/url-to-screenshot';
            this.SingOutLink = 'https://account.dataflowkit.com/signout';
            this.SignInLink = 'https://account.dataflowkit.com/signin';
		}
    }

    riseGoEvent(event) {
        this.goEvent.emit(event);
    }

    ngOnInit() {
        if (DFK.User.exists()) {
            this.UserName = DFK.User.Name;
            this.UserAvatar = DFK.User.Avatar;
            // DFK.User.refreshCredits();
            this.httpService.getUserCredits(DFK.User.APIKey).subscribe(
                UserCredits => this.updateUserCredits(UserCredits),
                error => console.error(error)
            );
        } else {
            this.UserName = '';
            this.UserAvatar = '';
        }
    }

    windowOnFocus() {
        DFK.User.refreshUser();
        if (DFK.User.exists()) {
            this.UserName = DFK.User.Name;
            this.UserAvatar = DFK.User.Avatar;
            // DFK.User.refreshCredits();
            this.httpService.getUserCredits(DFK.User.APIKey).subscribe(
                UserCredits => this.updateUserCredits(UserCredits),
                error => console.error(error)
            );
        } else {
            this.UserName = '';
            this.UserAvatar = '';
        }
    }

    updateUserCredits(uc) {
        this.balance = uc.credits;
    }

    userExists(): boolean {
        return DFK.User.exists();
    }
}
